import { render, staticRenderFns } from "./SendFailedImportFeedbackModal.vue?vue&type=template&id=0ecea8fe&"
import script from "./SendFailedImportFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./SendFailedImportFeedbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports